import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { Button, Col, Container, Row, Spinner } from 'reactstrap';
import { IGlobalContextProps, withGlobalContext } from 'src/context/global.context';
import { IProject, IProposition } from 'src/model';
import { listMyProjects, listMyPropositions } from 'src/services';
import { Svg } from '../shared/Svg';
import { Metric } from './Metric';
import { Onboarding } from './Onboarding';
import { ProjectList } from './ProjectList';
import { PropositionList } from './PropositiontList';

interface IDashboardState {
  loaded: boolean;
  projectList: IProject[];
  propositionList: IProposition[];
}



class Dashboard extends React.Component<
  IGlobalContextProps & RouteComponentProps,
  IDashboardState
> {
  public state = {
    loaded: false,
    projectList: [] as IProject[],
    propositionList: [] as IProposition[],
  };


  public createProject = async () => {
    const { history } = this.props;
    history.push(`/project/create`);
  };

  public async componentDidMount() {
    try {
      const propositionList = await listMyPropositions();
      if (propositionList) {
        this.setState({ propositionList });
      }
      const projectList = await listMyProjects();
      if (projectList) {
        this.setState({
          projectList: projectList.filter(
            (project: IProject) => project.meta.status !== 'hidden'
          ),
        });
      }
    } catch {
      this.setState({ loaded: true });
    }
     this.setState({ loaded: true });
  }

  public render() {
    const { loaded, propositionList, projectList } = this.state;
    const { user } = this.props.context;
    const newPropositionList = propositionList.filter(
      (proposition: IProposition) =>
        user && user.type === 'consultant'
          ? proposition.meta.status === 'hidden'
          : proposition.meta.status === 'validated'
    );
    const endedProjectsFilter = (project: IProject) =>
      project.meta.status === 'ended';
    const otherProjectsFilter = (project: IProject) =>
      project.meta.status !== 'ended' && project.meta.status !== 'canceled' ;
    const canceledProjectsFilter = (project: IProject) =>
      project.meta.status === 'canceled';
   

    const endedPropositionsFilter = (proposition: IProposition) =>
     // proposition.meta.status === 'refused' ||
     // proposition.meta.status === 'expired' ||
      (proposition.meta.status === 'accepted' &&
        proposition.project.meta.status === 'ended');
    const RefusedPropositionsFilter = (proposition: IProposition) =>
    proposition.meta.status === 'refused' 
    || proposition.meta.status === 'expired' 
    || proposition.meta.status === 'rejected'
    const otherPropositionsFilter = (proposition: IProposition) =>
      proposition.meta.status !== 'refused' &&
      proposition.meta.status !== 'rejected' &&
      proposition.meta.status !== 'expired' &&
      (proposition.meta.status !== 'accepted' ||
        proposition.project.meta.status !== 'ended');

    return !loaded ? (
      <Container
        className='d-flex flex-column justify-content-around align-items-center'
        style={{ minHeight: 'calc(100% - 180px)' }}
      >
        <div className='d-flex flex-column align-items-center'>
          <Spinner type='grow' color='primary' />
          <span className='mt-3'>Chargement...</span>
        </div>
      </Container>
    ) : (
      <Container style={{ minHeight: 'calc(100% - 145px)' }}>
        {projectList.length || propositionList.length ? (
          <Container className='pt-4'>
            <Row className='d-flex justify-content-between align-items-center mb-5'>
              {user && user.type === 'client' && (
                <Col md='6' sm='auto' className='d-flex align-items-center'>
                  <Button
                    className='d-flex align-items-center text-white bg-secondary m-2 border-0'
                    onClick={this.createProject}
                  >
                    <Svg width={48} fill='white' src='plus' className='mr-2' />
                    <span>
                      Nouveau
                      <br />
                      projet
                    </span>
                  </Button>
                  {newPropositionList.length ? (
                    <Button className='d-flex align-items-center text-white bg-secondary m-2 border-0'>
                      <span className='mr-3' style={{ fontSize: '48px' }}>
                        {newPropositionList.length}
                      </span>
                      <span>
                        {newPropositionList.length < 2
                          ? 'Nouvelle proposition reçue'
                          : 'Nouvelles propositions reçues'}
                      </span>
                    </Button>
                  ) : null}
                </Col>
              )}
              <Col sm='auto' className='d-flex justify-content-between'>
                {user && user.type === 'consultant' ? (
                  <>
                    <Metric
                      color='info'
                      label='projets'
                      metric={
                        propositionList.filter(otherPropositionsFilter).length
                      }
                      src='agile-process'
                      status='en cours'
                    />
                    <Metric
                      color='primary'
                      label='projets'
                      metric={
                        propositionList.filter(endedPropositionsFilter).length
                      }
                      src='finished'
                      status='terminés'
                    />
                  </>
                ) : (
                  <>
                    <Metric
                      color='info'
                      label='projets'
                      metric={projectList.filter(otherProjectsFilter).length}
                      src='agile-process'
                      status='en cours'
                    />
                    <Metric
                      color='primary'
                      label='projets'
                      metric={projectList.filter(endedProjectsFilter).length}
                      src='finished'
                      status='terminés'
                    />
                  </>
                )}
              </Col>
              {user &&
              user.type === 'consultant' &&
              newPropositionList.length ? (
                <Col md='6' sm='auto' className='d-flex justify-content-end'>
                  <Button className='d-flex align-items-center text-white bg-secondary m-2 border-0'>
                    <span className='mr-3' style={{ fontSize: '48px' }}>
                      {newPropositionList.length}
                    </span>
                    <span>
                      {newPropositionList.length < 2
                        ? 'Nouvelle proposition reçue'
                        : 'Nouvelles propositions reçues'}
                    </span>
                  </Button>
                </Col>
              ) : null}
            </Row>
            {user && user.type === 'client' ? (
              <>
                <ProjectList
                  label='Projets en cours'
                  filter={otherProjectsFilter}
                  projectList={projectList}
                  propositionList={propositionList}
                  src='agile-process'
                />
                <ProjectList
                  label='Projets terminés'
                  filter={endedProjectsFilter}
                  projectList={projectList}
                  propositionList={propositionList}
                  src='finished'
                />
                <ProjectList
                  label='Projets non aboutis'
                  filter={canceledProjectsFilter}
                  projectList={projectList}
                  propositionList={propositionList}
                  src='finger-wagging'
                />
              </>
            ) : (
              <>
                <PropositionList
                  label='Projets en cours'
                  propositionFilter={otherPropositionsFilter}
                  propositionList={propositionList}
                  src='agile-process'
                />
                <PropositionList
                  label='Projets terminés'
                  propositionFilter={endedPropositionsFilter}
                  propositionList={propositionList}
                  src='finished'
                />
                <PropositionList
                  label='Projets non remportés'
                  propositionFilter={RefusedPropositionsFilter}
                  propositionList={propositionList}
                  src='finger-wagging'
                />
              </>
            )}
          </Container>
        ) : (
          user &&
          loaded && (
            <Onboarding
              type={user.type}
              toggleProjectModal={this.createProject}
            />
          )
        )}
      </Container>
    );
  }
}

export const DashboardWithGlobalContext = withGlobalContext(
  withRouter(Dashboard)
);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Dashboard.tsx